export enum SubCauseTypes {
    CHOICE = "choice",
    VOICE = "voice",
    VOTE = "vote",
    ALL = "all"
}